import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'reverse'
})
export class ReversePipe implements PipeTransform {
  transform<T>(value: T[]): T[] {
    if (!value || !Array.isArray(value)) {
      return value
    }
    return [...value].reverse()
  }
}
